module.exports = __webpack_public_path__ + "assets/img/weitianshiFA.423cd63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weitianshiFA.png
// module id = txcr
// module chunks = 25 37 118 164 166